import FormMessage from 'components/Form/FormMessage/index';
import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { SelectStyled } from 'page/Application/ManageProductAndService/Product/component/FormDropDown/styled';

const FormDropDown = ({
  form,
  name,
  data,
  messageRequired,
  placeHolder,
}) => {
  const [idDomain, setIdDomain] = useState(null);

  const handleOnChange = (e) => {
    setIdDomain(e)
  }

  useEffect(() => {
    if (data?.length > 0 && data !== undefined) {
      if (form.getFieldsValue()?.partnerId) {
        setIdDomain(form.getFieldsValue()?.partnerId);
      }
      if (data.length === 1) {
        setIdDomain(data[0]?.value)
      }
    }
  }, [data, form]);

  useEffect(() => {
    if (data?.some((partner) => partner.value === idDomain)) {
      form.setFieldValue('partnerId', idDomain);
    } else {
      form.setFieldValue('partnerId', null);
    }
  }, [data, form, idDomain]);
  return (
    <Form.Item
      name={name}
      rules={[
        {
          required: data?.length > 0 || data === undefined,
          message: (
            <FormMessage
              text1={messageRequired}
              marginBottom={'12px'}
            ></FormMessage>
          ),
        },
      ]}
      extra={
        <FormMessage
          text1={
            '所属されている企業を選択する前に、メールアドレスを入力してください。'
          }
        />
      }
    >
      <SelectStyled
        popupMatchSelectWidth={false}
        options={data}
        placeholder={placeHolder}
        onChange={handleOnChange}
        disabled={data?.length < 2 || data === undefined}
        allowClear
      />
    </Form.Item>
  );
};

export default FormDropDown;
